const translations = {
  tr: {
    // Header
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımda',
      projects: 'Projeler',
      contact: 'İletişim',
      letsConnect: 'İletişime Geç'
    },
    // Hero
    hero: {
      title1: 'Bilgisayar',
      title2: 'Mühendisi',
      motto: '"Sınırlar geçmişte kaldı. Yapay zeka gelecek. Dil engeli olmadan küresel çalış."',
      description: 'İşletmeleri yenilikçi yapay zeka çözümleriyle güçlendiriyorum, taze fikirler, otomasyon ve verimlilik sunuyorum.',
      valueProposition: 'İş akışlarına zeka katıyor ve',
      nlp: 'NLP',
      deepLearning: 'Derin Öğrenme',
      automation: 'Otomasyon',
      valueProposition2: 'ile yeni fırsatlar yaratıyorum.',
      exploreSolutions: 'Çözümlerimi Keşfet',
      startProject: 'Küresel Proje Başlat'
    },
    // About
    about: {
      sectionTitle: 'Hakkımda',
      title1: 'Bilgisayar Mühendisi',
      title2: 'yapay zeka odaklı',
      title3: 'çözümler',
      bio1: '5 yılı aşkın yazılım geliştirme ve makine öğrenmesi deneyimimle, işletmelerin çalışma şeklini dönüştüren akıllı sistemler oluşturma konusunda uzmanlaşıyorum.',
      bio2: 'Bağlamı anlayan NLP modellerinden gerçek zamanlı anormallikleri tespit eden bilgisayarlı görü sistemlerine kadar, hem teknik olarak sağlam hem de pratik olarak kullanışlı çözümler sunmaya odaklanıyorum.',
      bio3: 'Şu anda İstanbul merkezli olarak, dünya genelinde müşterilerle yapay zeka entegrasyonu, full-stack geliştirme ve veri odaklı uygulamalar üzerinde çalışıyorum.',
      technologies: 'Teknolojiler'
    },
    // Projects
    projects: {
      sectionTitle: 'Portföy',
      title1: 'Öne Çıkan',
      title2: 'Projeler',
      subtitle: 'Son teknoloji ile gerçek problemlere gerçek çözümler',
      problem: 'Problem',
      solution: 'Çözüm',
      techStack: 'Teknoloji Yığını',
      liveDemo: 'Canlı Demo',
      sourceCode: 'Kaynak Kodu',
      openLiveDemo: 'Canlı Demoyu Aç',
      viewMore: 'Daha fazla proje görmek ister misiniz?',
      viewAllOnGithub: 'GitHub\'da Tümünü Gör',
      // Project items
      project1: {
        name: 'Sagopa Kajmer & Kumru AI Chatbot',
        problem: 'Hayranlar, sevdikleri sanatçıların tarzında özgün içerikler oluşturamıyor ve etkileşime giremiyor',
        solution: 'Sagopa Kajmer ve Kumru\'nun şarkı sözlerinden eğitilmiş, karakterlerini taklit eden LoRA fine-tuned LLM chatbot'
      },
      chatDemo: {
        placeholder: 'Sagopa veya Kumru\'ya bir şey yaz...',
        send: 'Gönder',
        thinking: 'Düşünüyor...',
        error: 'Bağlantı hatası. Tekrar deneyin.',
        welcome: 'Selam ben Sago ruhlu bir chatbotum. Sor gelsin!'
      },
      project2: {
        name: 'Bilgisayarlı Görü Kalite Kontrolü',
        problem: 'Manuel kalite kontrol sınırlamaları nedeniyle üretim hataları yıllık milyarlarca dolara mal oluyor',
        solution: 'Milisaniye yanıt süresiyle %99.5 doğruluk elde eden YOLO v8 kullanan gerçek zamanlı hata tespiti'
      },
      project3: {
        name: 'NLP Chatbot Platformu',
        problem: 'Müşteri desteği 7/24 çok dilli sorgular ve tekrarlayan sorularla bunalmış durumda',
        solution: 'Bağlam farkındalıklı yanıtlar ve insan devri ile 12+ dili destekleyen NLP destekli yapay zeka'
      },
      project4: {
        name: 'Analitik Paneli',
        problem: 'Statik raporlar ve gerçek zamanlı veri içgörüsü eksikliği nedeniyle iş kararları gecikiyor',
        solution: 'Canlı görselleştirmelerle milyonlarca veri noktasını işleyen interaktif BI platformu'
      },
      project5: {
        name: 'Mikroservis Platformu',
        problem: 'Monolitik mimari trafik artışlarını ve sık dağıtım ihtiyaçlarını karşılayamıyordu',
        solution: '100K+ eşzamanlı kullanıcıyı yöneten otomatik ölçeklendirmeli bulut tabanlı mikroservisler'
      }
    },
    // Contact
    contact: {
      sectionTitle: 'İletişime Geç',
      title1: 'Birlikte',
      title2: 'Çalışalım',
      subtitle: 'Bir sonraki projenize başlamaya hazır mısınız? Fikirlerinizi gerçeğe dönüştürmenize yardımcı olmak için buradayım.',
      email: 'E-posta',
      location: 'Konum',
      locationValue: 'İstanbul, Türkiye',
      working: 'Çalışma',
      workingValue: 'Dünya Genelinde Uzaktan',
      connectWith: 'Benimle bağlantı kurun:',
      available: 'Projeler İçin Müsait',
      availableDesc: 'Şu anda yeni projeler ve iş birlikleri kabul ediyorum. Yanıt süresi: 24 saat içinde.',
      yourName: 'Adınız',
      yourEmail: 'E-postanız',
      projectType: 'Proje Türü',
      selectProjectType: 'Bir proje türü seçin',
      subject: 'Konu',
      subjectPlaceholder: 'Proje sorgusu',
      message: 'Mesaj',
      messagePlaceholder: 'Projeniz hakkında bilgi verin...',
      sendMessage: 'Mesaj Gönder',
      messageSent: 'Mesaj Gönderildi!',
      thankYou: 'İletişime geçtiğiniz için teşekkürler. 24 saat içinde size dönüş yapacağım.',
      sendAnother: 'Başka Mesaj Gönder',
      projectTypes: [
        'Yapay Zeka/ML Model Geliştirme',
        'Bilgisayarlı Görü Çözümleri',
        'NLP & Chatbot Geliştirme',
        'Web Uygulama Geliştirme',
        'Veri Analitiği & Görselleştirme',
        'Danışmanlık & Tavsiye'
      ]
    },
    // Footer
    footer: {
      description: 'Yapay zeka çözümlerinde uzmanlaşmış Bilgisayar Mühendisi, fikirleri gerçeğe dönüştüren akıllı sistemler geliştiriyorum.',
      quickLinks: 'Hızlı Bağlantılar',
      expertise: 'Uzmanlık Alanları',
      startProject: 'Proje Başlat',
      startProjectDesc: 'Fikirlerinizi hayata geçirmeye hazır mısınız? Hadi birlikte muhteşem bir şeyler inşa edelim.',
      getInTouch: 'İletişime Geç',
      rights: 'Tüm hakları saklıdır.',
      builtWith: 'ile yapıldı',
      expertiseAreas: [
        'Yapay Zeka',
        'Makine Öğrenmesi',
        'Derin Öğrenme',
        'Bilgisayarlı Görü',
        'NLP & Chatbotlar',
        'Full-Stack Geliştirme'
      ]
    }
  },
  en: {
    // Header
    nav: {
      home: 'Home',
      about: 'About',
      projects: 'Projects',
      contact: 'Contact',
      letsConnect: "Let's Connect"
    },
    // Hero
    hero: {
      title1: 'Computer',
      title2: 'Engineer',
      motto: '"Borders are legacy. AI is the future. Work globally without language barriers."',
      description: 'I empower businesses with innovative AI solutions, bringing fresh ideas, automation, and efficiency.',
      valueProposition: 'Bringing intelligence to workflows and creating new opportunities through',
      nlp: 'NLP',
      deepLearning: 'Deep Learning',
      automation: 'Automation',
      valueProposition2: '.',
      exploreSolutions: 'Explore My Solutions',
      startProject: 'Start a Global Project'
    },
    // About
    about: {
      sectionTitle: 'About',
      title1: 'Computer Engineer focused on',
      title2: 'AI-powered',
      title3: 'solutions',
      bio1: 'With over 5 years of experience in software development and machine learning, I specialize in creating intelligent systems that transform how businesses operate.',
      bio2: 'From NLP models that understand context to computer vision systems that detect anomalies in real-time, I focus on delivering solutions that are both technically robust and practically useful.',
      bio3: 'Currently based in Istanbul, working with clients globally on AI integration, full-stack development, and data-driven applications.',
      technologies: 'Technologies'
    },
    // Projects
    projects: {
      sectionTitle: 'Portfolio',
      title1: 'Featured',
      title2: 'Projects',
      subtitle: 'Real solutions solving real problems with cutting-edge technology',
      problem: 'Problem',
      solution: 'Solution',
      techStack: 'Tech Stack',
      liveDemo: 'Live Demo',
      sourceCode: 'Source Code',
      openLiveDemo: 'Open Live Demo',
      viewMore: 'Want to see more projects?',
      viewAllOnGithub: 'View All on GitHub',
      // Project items
      project1: {
        name: 'Sagopa Kajmer & Kumru AI Chatbot',
        problem: 'Fans cannot create original content or interact in the style of their favorite artists',
        solution: 'LoRA fine-tuned LLM chatbot trained on Sagopa Kajmer and Kumru\'s lyrics, mimicking their unique characters'
      },
      chatDemo: {
        placeholder: 'Write something to Sagopa or Kumru...',
        send: 'Send',
        thinking: 'Thinking...',
        error: 'Connection error. Please try again.',
        welcome: 'Yo, I\'m a Sago-spirited chatbot. Ask away!'
      },
      project2: {
        name: 'Computer Vision QC',
        problem: 'Manufacturing defects cost billions annually due to manual quality control limitations',
        solution: 'Real-time defect detection using YOLO v8 achieving 99.5% accuracy with millisecond response'
      },
      project3: {
        name: 'NLP Chatbot Platform',
        problem: 'Customer support overwhelmed with 24/7 multilingual queries and repetitive questions',
        solution: 'NLP-powered AI supporting 12+ languages with context-aware responses and human handoff'
      },
      project4: {
        name: 'Analytics Dashboard',
        problem: 'Business decisions delayed by static reports and lack of real-time data insights',
        solution: 'Interactive BI platform processing millions of data points with live visualizations'
      },
      project5: {
        name: 'Microservices Platform',
        problem: "Monolithic architecture couldn't handle traffic spikes and frequent deployment needs",
        solution: 'Cloud-native microservices with auto-scaling, handling 100K+ concurrent users'
      }
    },
    // Contact
    contact: {
      sectionTitle: 'Get In Touch',
      title1: "Let's Work",
      title2: 'Together',
      subtitle: "Ready to start your next project? I'm here to help transform your ideas into reality.",
      email: 'Email',
      location: 'Location',
      locationValue: 'Istanbul, Turkey',
      working: 'Working',
      workingValue: 'Worldwide Remote',
      connectWith: 'Connect with me:',
      available: 'Available for Projects',
      availableDesc: 'Currently accepting new projects and collaborations. Response time: within 24 hours.',
      yourName: 'Your Name',
      yourEmail: 'Your Email',
      projectType: 'Project Type',
      selectProjectType: 'Select a project type',
      subject: 'Subject',
      subjectPlaceholder: 'Project inquiry',
      message: 'Message',
      messagePlaceholder: 'Tell me about your project...',
      sendMessage: 'Send Message',
      messageSent: 'Message Sent!',
      thankYou: "Thank you for reaching out. I'll get back to you within 24 hours.",
      sendAnother: 'Send Another Message',
      projectTypes: [
        'AI/ML Model Development',
        'Computer Vision Solutions',
        'NLP & Chatbot Development',
        'Web Application Development',
        'Data Analytics & Visualization',
        'Consulting & Advisory'
      ]
    },
    // Footer
    footer: {
      description: 'Computer Engineer specialized in AI solutions, building intelligent systems that transform ideas into reality.',
      quickLinks: 'Quick Links',
      expertise: 'Expertise',
      startProject: 'Start a Project',
      startProjectDesc: 'Ready to bring your ideas to life? Let\'s collaborate and build something amazing together.',
      getInTouch: 'Get in Touch',
      rights: 'All rights reserved.',
      builtWith: 'Built with',
      expertiseAreas: [
        'Artificial Intelligence',
        'Machine Learning',
        'Deep Learning',
        'Computer Vision',
        'NLP & Chatbots',
        'Full-Stack Development'
      ]
    }
  },
  de: {
    // Header
    nav: {
      home: 'Startseite',
      about: 'Über mich',
      projects: 'Projekte',
      contact: 'Kontakt',
      letsConnect: 'Kontakt aufnehmen'
    },
    // Hero
    hero: {
      title1: 'Computer',
      title2: 'Ingenieur',
      motto: '"Grenzen sind Vergangenheit. KI ist die Zukunft. Arbeite global ohne Sprachbarrieren."',
      description: 'Ich stärke Unternehmen mit innovativen KI-Lösungen und bringe frische Ideen, Automatisierung und Effizienz.',
      valueProposition: 'Ich bringe Intelligenz in Arbeitsabläufe und schaffe neue Möglichkeiten durch',
      nlp: 'NLP',
      deepLearning: 'Deep Learning',
      automation: 'Automatisierung',
      valueProposition2: '.',
      exploreSolutions: 'Meine Lösungen erkunden',
      startProject: 'Globales Projekt starten'
    },
    // About
    about: {
      sectionTitle: 'Über mich',
      title1: 'Computeringenieur fokussiert auf',
      title2: 'KI-gestützte',
      title3: 'Lösungen',
      bio1: 'Mit über 5 Jahren Erfahrung in Softwareentwicklung und maschinellem Lernen spezialisiere ich mich auf die Entwicklung intelligenter Systeme, die die Arbeitsweise von Unternehmen transformieren.',
      bio2: 'Von NLP-Modellen, die Kontext verstehen, bis hin zu Computer-Vision-Systemen, die Anomalien in Echtzeit erkennen, konzentriere ich mich auf die Bereitstellung von Lösungen, die sowohl technisch robust als auch praktisch nützlich sind.',
      bio3: 'Derzeit in Istanbul ansässig, arbeite ich mit Kunden weltweit an KI-Integration, Full-Stack-Entwicklung und datengesteuerten Anwendungen.',
      technologies: 'Technologien'
    },
    // Projects
    projects: {
      sectionTitle: 'Portfolio',
      title1: 'Ausgewählte',
      title2: 'Projekte',
      subtitle: 'Echte Lösungen für echte Probleme mit modernster Technologie',
      problem: 'Problem',
      solution: 'Lösung',
      techStack: 'Tech-Stack',
      liveDemo: 'Live-Demo',
      sourceCode: 'Quellcode',
      openLiveDemo: 'Live-Demo öffnen',
      viewMore: 'Möchten Sie mehr Projekte sehen?',
      viewAllOnGithub: 'Alle auf GitHub ansehen',
      // Project items
      project1: {
        name: 'Sagopa Kajmer & Kumru AI Chatbot',
        problem: 'Fans können keine originellen Inhalte im Stil ihrer Lieblingskünstler erstellen oder interagieren',
        solution: 'LoRA-feinabgestimmter LLM-Chatbot, trainiert auf Sagopa Kajmer und Kumrus Texten, der ihre einzigartigen Charaktere nachahmt'
      },
      chatDemo: {
        placeholder: 'Schreib etwas an Sagopa oder Kumru...',
        send: 'Senden',
        thinking: 'Denkt nach...',
        error: 'Verbindungsfehler. Bitte versuchen Sie es erneut.',
        welcome: 'Yo, ich bin ein Sago-inspirierter Chatbot. Frag los!'
      },
      project2: {
        name: 'Computer Vision Qualitätskontrolle',
        problem: 'Fertigungsfehler kosten jährlich Milliarden aufgrund manueller Qualitätskontrollbeschränkungen',
        solution: 'Echtzeit-Fehlererkennung mit YOLO v8, die 99,5% Genauigkeit mit Millisekunden-Reaktion erreicht'
      },
      project3: {
        name: 'NLP-Chatbot-Plattform',
        problem: 'Kundensupport überfordert mit 24/7 mehrsprachigen Anfragen und sich wiederholenden Fragen',
        solution: 'NLP-gestützte KI, die 12+ Sprachen mit kontextbewussten Antworten und menschlicher Übergabe unterstützt'
      },
      project4: {
        name: 'Analytik-Dashboard',
        problem: 'Geschäftsentscheidungen verzögert durch statische Berichte und fehlende Echtzeit-Dateneinblicke',
        solution: 'Interaktive BI-Plattform, die Millionen von Datenpunkten mit Live-Visualisierungen verarbeitet'
      },
      project5: {
        name: 'Microservices-Plattform',
        problem: 'Monolithische Architektur konnte Traffic-Spitzen und häufige Bereitstellungsanforderungen nicht bewältigen',
        solution: 'Cloud-native Microservices mit automatischer Skalierung, die 100K+ gleichzeitige Benutzer verarbeiten'
      }
    },
    // Contact
    contact: {
      sectionTitle: 'Kontakt',
      title1: 'Lass uns',
      title2: 'zusammenarbeiten',
      subtitle: 'Bereit, Ihr nächstes Projekt zu starten? Ich bin hier, um Ihre Ideen in die Realität umzusetzen.',
      email: 'E-Mail',
      location: 'Standort',
      locationValue: 'Istanbul, Türkei',
      working: 'Arbeit',
      workingValue: 'Weltweit Remote',
      connectWith: 'Verbinden Sie sich mit mir:',
      available: 'Verfügbar für Projekte',
      availableDesc: 'Akzeptiere derzeit neue Projekte und Zusammenarbeiten. Antwortzeit: innerhalb von 24 Stunden.',
      yourName: 'Ihr Name',
      yourEmail: 'Ihre E-Mail',
      projectType: 'Projekttyp',
      selectProjectType: 'Wählen Sie einen Projekttyp',
      subject: 'Betreff',
      subjectPlaceholder: 'Projektanfrage',
      message: 'Nachricht',
      messagePlaceholder: 'Erzählen Sie mir von Ihrem Projekt...',
      sendMessage: 'Nachricht senden',
      messageSent: 'Nachricht gesendet!',
      thankYou: 'Vielen Dank für Ihre Kontaktaufnahme. Ich werde mich innerhalb von 24 Stunden bei Ihnen melden.',
      sendAnother: 'Weitere Nachricht senden',
      projectTypes: [
        'KI/ML-Modellentwicklung',
        'Computer-Vision-Lösungen',
        'NLP & Chatbot-Entwicklung',
        'Webanwendungsentwicklung',
        'Datenanalyse & Visualisierung',
        'Beratung & Beratung'
      ]
    },
    // Footer
    footer: {
      description: 'Computeringenieur spezialisiert auf KI-Lösungen, der intelligente Systeme entwickelt, die Ideen in die Realität umsetzen.',
      quickLinks: 'Schnelllinks',
      expertise: 'Expertise',
      startProject: 'Projekt starten',
      startProjectDesc: 'Bereit, Ihre Ideen zum Leben zu erwecken? Lassen Sie uns zusammenarbeiten und etwas Großartiges bauen.',
      getInTouch: 'Kontakt aufnehmen',
      rights: 'Alle Rechte vorbehalten.',
      builtWith: 'Erstellt mit',
      expertiseAreas: [
        'Künstliche Intelligenz',
        'Maschinelles Lernen',
        'Deep Learning',
        'Computer Vision',
        'NLP & Chatbots',
        'Full-Stack-Entwicklung'
      ]
    }
  }
};

export default translations;
